import { forwardRef } from "react";

import { ManagedFormControl } from "@/common/components/Form/ManagedFormControl";
import { IconPicker, IconPickerProps } from "@/common/components/IconPicker";
import {
  FormElementBaseProps,
  useManagedFormControlProps,
} from "@/common/hooks/useManagedFormControlProps";
import { mergeFunctions } from "@/common/utils/mergeFunctions";
import { mergeRefs } from "@/common/utils/mergeRefs";
import { DistributiveOmit } from "@reflag/shared/utils/types";

export type FormIconPickerProps = FormElementBaseProps &
  DistributiveOmit<IconPickerProps, "value">;

export const FormIconPicker = forwardRef<
  HTMLButtonElement,
  FormIconPickerProps
>(({ _control, onChange, ...rest }, ref) => {
  const [managedProps, pickerProps] = useManagedFormControlProps(rest);

  return (
    <ManagedFormControl
      {..._control}
      {...managedProps}
      render={({ field }) => (
        <IconPicker
          {...pickerProps}
          ref={mergeRefs(field.ref, ref)}
          value={field.value}
          onChange={mergeFunctions(field.onChange, onChange)}
        />
      )}
      w="auto"
    />
  );
});

FormIconPicker.displayName = "FormIconPicker";
